/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import DynamicEntityRow from './DynamicEntityRow';

let DynamicEntityRows = ({
  children, router, IconComponent
}: any): React.Element => (
  TBody({
    children: children.map(child => (
      <DynamicEntityRow
        IconComponent={IconComponent}
        key={ child.id }
        router={ router }
      >
        { child }
      </DynamicEntityRow>
    ))
  })
);

export default DynamicEntityRows;
